/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['endpoints', 'rest/request/singleRequestServiceFactory', 'rest/request/batchRequestServiceFactory',
    'apiKeyNames'],
function(endpoints, singleRequestServiceFactory, batchRequestServiceFactory, ApiKeyNames) {

    var keyName = ApiKeyNames.search;

    return {
        reverseGeocode: singleRequestServiceFactory(endpoints.reverseGeocode, keyName),
        batch: batchRequestServiceFactory(100, {single: endpoints.batchSearchQuery,
                                                batch: endpoints.batchSearch,
                                                batchSync: endpoints.batchSyncSearch}, keyName)
    };
}
);



// WEBPACK FOOTER //
// ./rest/reverseGeocode.js